<template>
  <v-card>
    <!-- <v-card-title>
      <div>
        <div class="headline">Details</div>
      </div>
    </v-card-title> -->
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon v-if="tranMode === 'New'">mdi-plus</v-icon>
      <v-icon v-if="tranMode === 'Review'">mdi-pencil</v-icon>
      <v-icon v-if="tranMode === 'Query'">mdi-magnify</v-icon>
      <v-toolbar-title v-if="tranMode === 'New'">Create New Clause</v-toolbar-title>
      <v-toolbar-title v-if="tranMode === 'Review'">Edit Clause</v-toolbar-title>
      <v-toolbar-title v-if="tranMode === 'Query'">View Existing Clause</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="mr-2" v-if="tranMode !== 'New'" color="primary" @click="doPolType()">
        Permitted Policy Type
        <v-icon right>mdi-view-list</v-icon>
      </v-btn>
      <v-btn v-if="tranMode !== 'New'" color="primary" @click="doBusCls()">
        Permitted Business Class
        <v-icon right>mdi-view-list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs4 v-if="tranMode === 'New'">
            <v-text-field
              v-model="clseForm.clseNo"
              :label="labels.clseNo"
              :error-messages="errors.collect('clseNo')"
              data-vv-name="clseNo"
              :data-vv-as="labels.clseNo"
              v-validate="'required|param|max:6'"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              :label="labels.clseTitle"
              v-model="clseForm.clseTitle"
              :error-messages="errors.collect('clseTitle')"
              v-validate="'required|max:400'"
              data-vv-name="clseTitle"
              :data-vv-as="labels.clseTitle"
              :counter="400"
              :disabled="tranMode === 'Query'"
            ></v-textarea>
            <v-textarea
              :label="labels.clseTxt"
              v-model="clseForm.clseTxt"
              :error-messages="errors.collect('clseTxt')"
              v-validate="'max:8000'"
              data-vv-name="clseTxt"
              :data-vv-as="labels.clseTxt"
              :counter="8000"
              :disabled="tranMode === 'Query'"
            ></v-textarea>
          </v-flex>
          <v-flex xs12 v-if="tranMode !== 'Query'">
            <v-checkbox :label="labels.isPremWar" v-model="clseForm.isPremWar"></v-checkbox>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.isPremWar }}</v-subheader>
            <div class="queryValue">{{ clseForm.isPremWar }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
            <div class="queryValue">{{ clseForm.createdBy }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDate(clseForm.createdDate) }}</div>
          </v-flex>
          <v-flex xs6 v-if="tranMode !== 'New'">
            <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
            <div class="queryValue">{{ clseForm.modifiedBy }}</div>
          </v-flex>
          <v-flex xs6 v-if="tranMode !== 'New'">
            <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
            <div class="queryValue">{{ formatDate(clseForm.modifiedDate) }}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" dark @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
      <v-btn v-if="tranMode !== 'Query'" color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
        Save
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        clseNo: 'Clause No.*',
        clseTitle: 'Clause Title*',
        clseTxt: 'Clause Text',
        isPremWar: 'Premium Warranty',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      clseForm: {
        clseNo: undefined,
        clseTitle: undefined,
        clseTxt: undefined,
        isPremWar: false,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined
      },
      menu: [],
      newClause: false,
      submitting: false
    }
  },
  computed: {
    clsemenu() {
      return this.$store.state.docFormatParam.menu
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.clsemenu.getClause
      if (apiURI) {
        this.loading = true
        try {
          const expand = { clseNo: this.clseNo }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // General
            this.clseForm.clseNo = data.clause.clseNo
            this.clseForm.clseTitle = data.clause.clseTitle
            this.clseForm.clseTxt = data.clause.clseTxt
            this.clseForm.isPremWar = data.clause.isPremWar
            // Audit
            this.clseForm.createdBy = data.createdBy
            this.clseForm.createdDate = data.createdDate
            this.clseForm.modifiedBy = data.modifiedBy
            this.clseForm.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doBack() {
      this.$router.push({ name: 'clause' })
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newClause) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.clsemenu.updateClause
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.clseForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'reviewClause' })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doCreate() {
      const apiURI = this.clsemenu.createClause
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.clseForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'clause' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    doPolType() {
      this.$router.push({ name: 'polTypeClauseMenu', params: { clseNo: this.clseNo, clseTitle: this.clseTitle } })
    },
    doBusCls() {
      this.$router.push({ name: 'busClsClauseMenu', params: { clseNo: this.clseNo, clseTitle: this.clseForm.clseTitle } })
    },
    doCancel() {
      this.$router.push({ name: 'clause' })
    }
  },
  created() {
    if (this.tranMode === 'New') {
      this.newClause = true
      this.clseForm.createdBy = this.$store.state.token.firstName
      this.clseForm.createdDate = new Date()
    } else {
      this.doInit()
    }
  },
  props: ['clseNo', 'clseTitle', 'tranMode'],
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
</style>
